import { PSwitch } from '@porsche-design-system/components-react';
import { Form } from 'antd';
import { useField } from 'formik';
import { type SwitchProps } from '../../../components/fields/SwitchField';

const SwitchField = ({ name, required, label, tooltip, disabled }: SwitchProps) => {
    const [field, meta, helpers] = useField({ name });

    return (
        <Form.Item required={required}>
            <PSwitch
                {...field}
                alignLabel="start"
                checked={field.value}
                disabled={disabled}
                onUpdate={value => helpers.setValue(value)}
            >
                {label}
            </PSwitch>
        </Form.Item>
    );
};

export default SwitchField;
